import HundredBricksAPI from '../../../HundredBricksAPI';
import { APIError } from '../../../../api';
import { BricksOnSaleSummary, BricksOnSaleSummaryError, OnSaleInvalidPropertyId, OnSalePropertyIsNotRegistered } from './bricksOnSaleSummary';
class OnSalePropertyAPI extends HundredBricksAPI {
    async getBricksOnSaleSummary(propertyId) {
        try {
            const { data } = await this.client.get(`v1/properties/${propertyId}/bricks/onSale`);
            return new BricksOnSaleSummary(data);
        }
        catch (error) {
            if (error instanceof APIError) {
                switch (error.code) {
                    case 'INVALID_PROPERTY_ID':
                        throw new OnSaleInvalidPropertyId(propertyId, { cause: error });
                    case 'PROPERTY_NOT_FOUND':
                        throw new OnSalePropertyIsNotRegistered(propertyId, { cause: error });
                    default:
                        throw new BricksOnSaleSummaryError({ cause: error });
                }
            }
            else if (error instanceof Error) {
                throw new BricksOnSaleSummaryError('Unexpected error when obtaining onsale bricks summary', { cause: error });
            }
            else {
                throw new BricksOnSaleSummaryError(`Unexpected error when obtaining onsale bricks summary: '${error}'`);
            }
        }
    }
}
export default OnSalePropertyAPI;
